import Cookies from 'js-cookie';

export const setCookie = (key, value, expires) => {
  if (!Cookies.get(key)) {
    Cookies.set(key, value, { expires });
  }
};

export const getCookie = (key) => {
  if (!Cookies.get(key)) {
    return null;
  }
  return Cookies.get(key);
};

const LP_LEADFORM = 'LP_LEADFORM';

/**
 * set pathname in landing_page key into cookie
 * if not exist previously
 * store on cookie in the browser for 14 days
 * @param {String} basePath - base path
 * @param {String} asPath - the remaining path after the base path
 */
export const setLandingPage = (basePath, asPath) => {
  const pathname = `${basePath}${asPath}`;
  setCookie('landing_page', pathname, 14);
};

/**
 * clear/remove LP_LEADFORM cookie
 */
export const removeLeadFormCookie = (key) => {
  Cookies.remove(key);
};

/**
 * set LP_LEADFORM into cookie
 * if not exist previously
 * store on cookie in the browser for 30 days
 */
export const setLeadFormCookie = (lfData) => {
  const LP_LEADFORM_DATA = {};

  LP_LEADFORM_DATA.fullName = lfData.fullName ? lfData.fullName : '';
  LP_LEADFORM_DATA.phoneNumber = lfData.phoneNumber ? lfData.phoneNumber : '';
  LP_LEADFORM_DATA.email = lfData.email ? lfData.email : '';
  // life data
  LP_LEADFORM_DATA.gender = lfData.gender ? lfData.gender : '';
  LP_LEADFORM_DATA.age = lfData.age ? lfData.age : '17';
  // auto data
  LP_LEADFORM_DATA.brandId = lfData.brandId ? lfData.brandId : '';
  LP_LEADFORM_DATA.modelId = lfData.modelId ? lfData.modelId : '';
  LP_LEADFORM_DATA.typeId = lfData.typeId ? lfData.typeId : '';
  LP_LEADFORM_DATA.yearId = lfData.yearId ? lfData.yearId : '';
  LP_LEADFORM_DATA.brand = lfData.brand ? lfData.brand : '';
  LP_LEADFORM_DATA.model = lfData.model ? lfData.model : '';
  LP_LEADFORM_DATA.type = lfData.type ? lfData.type : '';
  LP_LEADFORM_DATA.year = lfData.year ? lfData.year : '';
  LP_LEADFORM_DATA.area = lfData.area ? lfData.area : '';
  LP_LEADFORM_DATA.areaCode = lfData.areaCode ? lfData.areaCode : '';
  LP_LEADFORM_DATA.namePlan = lfData.namePlan ? lfData.namePlan : '';
  // business data
  LP_LEADFORM_DATA.company = lfData.company ? lfData.company : '';
  LP_LEADFORM_DATA.number_of_employees = lfData.number_of_employees
    ? lfData.number_of_employees
    : '';

  if (Cookies.get(LP_LEADFORM)) {
    removeLeadFormCookie(LP_LEADFORM);
  }

  setCookie(LP_LEADFORM, LP_LEADFORM_DATA, 30);
};

/**
 * get LP_LEADFORM cookie
 */
export const getLeadFormCookie = () => {
  const leadFormCookie = Cookies.get(LP_LEADFORM);

  if (!leadFormCookie) {
    return {};
  }

  return JSON.parse(leadFormCookie);
};
